<res-base-modal [modalTitle]="modalTitle" [modalAutomationId]="automationId" primaryButtonLabel="OK"
    (primaryButtonActionEmt)="ok()" [isPrimaryBtnEnabled]="okEnabled()" secondaryButtonLabel="Cancel"
    (closeButtonActionEmt)="closeModal()" [modalHelpIndex]="modalHelpIndex" [modalClass]="modalClass"
    [(isBusy)]="isBusy" [(isBusyMessage)]="isBusyMessage">
    <div class="export-row">
        <label>Threshold:</label>
        <input type="text" [(ngModel)]="nearDuplicatesThreshold" (keypress)="restrictNumeric($event)"
            (ngModelChange)="validation.nearDuplicatesThreshold.change()"
            (blur)="validation.nearDuplicatesThreshold.blur()"
            [attr.data-automation-id]="automationId + '-near-duplicates-threshold-input'"
            [(resScrollablePopover)]="validation.nearDuplicatesThreshold.invalid"
            [popoverErrorMessage]="validation.nearDuplicatesThreshold.errorMessage" popoverType="error"
            popoverPlacement="bottom" [popoverAutomationId]="automationId + '-near-duplicates-threshold-error-message'">
        <label>(0-99)</label>
    </div>
    <div class="export-row">
        <label>Minimum Terms:</label>
        <input type="text" [(ngModel)]="nearDuplicatesMinTermCount" (keypress)="restrictNumeric($event)"
            [attr.data-automation-id]="automationId + '-near-duplicates-minimum-terms-input'"
            (ngModelChange)="validation.nearDuplicatesMinTermCount.change()"
            (blur)="validation.nearDuplicatesMinTermCount.blur()"
            [(resScrollablePopover)]="validation.nearDuplicatesMinTermCount.invalid"
            [popoverErrorMessage]="validation.nearDuplicatesMinTermCount.errorMessage" popoverType="error"
            popoverPlacement="bottom"
            [popoverAutomationId]="automationId + '-near-duplicates-minimum-terms-error-message'">
    </div>
    <div class="export-row">
        <res-custom-checkbox class="nested-margin"
            [automationId]="automationId + '-near-duplicates-process-attachments'"
            [(ngModel)]="nearDuplicatesProcessAttachments" content="Process Attachments"
            [isDisabled]="!nearDuplicatesProcessAttachmentsEnabled()">
        </res-custom-checkbox>
    </div>
</res-base-modal>